import { render, staticRenderFns } from "./PaginationCatalog.vue?vue&type=template&id=79c0479f&lang=pug"
import script from "./PaginationCatalog.vue?vue&type=script&lang=js"
export * from "./PaginationCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79c0479f')) {
      api.createRecord('79c0479f', component.options)
    } else {
      api.reload('79c0479f', component.options)
    }
    module.hot.accept("./PaginationCatalog.vue?vue&type=template&id=79c0479f&lang=pug", function () {
      api.rerender('79c0479f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaginationCatalog.vue"
export default component.exports